import {connect} from '../../../../redux/utils'
import {showEditor} from '../selectors'
import {bindActionCreators} from 'redux'
import {closeEditor} from "../actions"
import HierarchyAssignmentsEditorPanel from '../../components/hierarchyAssignmentsEditor/HierarchyAssignmentsEditorPanel'
import ManagementAssignmentsEditor from './ManagementAssignmentsEditor'
import {PANEL_TYPES} from '../../../../panels/constants'
import {setEventPreventHidingEditUserSlidingPanel, setEventPreventHidingManagementAssignmentsSlidingPanel} from '../../../../panels/utils'
import {closeAllPanels} from '../../common/actions'

export class ManagementAssignmentsEditorPanel extends HierarchyAssignmentsEditorPanel {
    constructor(params) {
        super({
            hierarchyAssignmentsEditor: new ManagementAssignmentsEditor(),
            extraClass: 'userManagement_managementAssignmentsEditorPanel editUserAssignmentPanel',
            panelType: PANEL_TYPES.MANAGEMENT_ASSIGNMENTS_EDITOR,
            onClickContent: e => {
                setEventPreventHidingEditUserSlidingPanel(e)
                setEventPreventHidingManagementAssignmentsSlidingPanel(e)
            },
            ...params
        })
    }
}

export default connect(
    state => ({
        show: showEditor(state)
    }),
    dispatch => ({
        closeEditor: bindActionCreators(closeEditor, dispatch),
        closeAllPanels: bindActionCreators(closeAllPanels, dispatch)
    })
)(ManagementAssignmentsEditorPanel)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/managementAssignmentsEditor/components/ManagementAssignmentsEditorPanel.js